import LogoWithText from "~/branding/cdcr/full-text-logo.svg";
import Logo from "~/branding/cdcr/logo.svg";
import type { TenantDefinition } from "../types";

const cdcrTenant: TenantDefinition = {
	id: "cdcr",
	name: "uTranscribe — CDCR",
	theme: "cdcr",
	branding: {
		name: "uTranscribe — CDCR",
		theme: "cdcr",
		Logo,
		LogoWithText,
	},
	login: {
		teamTitle: "CDCR Team",
		signInIconSrc: "/ccr-logo.svg",
		sponsorLogoSrc: "/sponsor-logos.svg",
	},
};

export default cdcrTenant;
